import styled from 'styled-components';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
export var Footnotes = styled(ParagraphSmall).withConfig({
  displayName: "Footnotes",
  componentId: "sc-ewj2ju-0"
})(["max-width:100%;font-size:80%;"]);